import { Component } from 'react'
import { gql } from "@apollo/client"
import { Col, Row, Input } from 'reactstrap'
import ListingFilters from "../Material/ListingFilters"
import toTitleCase from '../Functions/toTitleCase'
import updateFilters from "../Functions/updateFilters"
import getFilterValuesFromQueryString from "../Functions/getFilterValuesFromQueryString"
import handleConfigurationChange from "../Functions/handleConfigurationChange"
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { LEGACY_SYSTEM_OPTIONS } from '../Constants'

const AllTpasQuery = gql`
    query AllTpasQuery($claimType:String) {
        optionsList: allTpas(claimType:$claimType) {
            edges {
                node {
                    id
                    name
                }
            }
        }
    }
`

const AllBranchesQuery = gql`query AllBranchesQuery {
    optionsList: allBranches(isUserScoped:true) {
        edges {
            node {
                id
                name
            }
        }
    }
}`

const RepsQuery = gql`
    query AllRepsQuery($groups:[String], $orderBy:[String]){
        optionsList: allReps(isStaff:true, isActive:true, groups:$groups, orderBy:$orderBy){
            edges{
                node{
                    id
                    name
                    username
                    firstName
                    lastName
                }
            }
        }
    }
`

const SubrogationStatusOptionsQuery = gql`query SubrogationStatusOptionsQuery {
    optionsList: __type(name: "IncidentsSubrogationClaimStatusChoices") {
        states: enumValues {
            name
            description
        }
    }
}`

class SubrogationClaimListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            configurations: null,
        }
    }

    getFilterConfigurations = () => {
        return [
            { type: "text", name: "searchTerm", title: "Search Term", placeholder: "Search By Claim #, Incident, Party", showFilter: false },
            { type: "select", name: "tpaId", title: "TPA", placeholder: "Filter By TPA", optionsQuery: AllTpasQuery, variables: { claimType: "SUBROGATION" }, valueSelector: "id", labelSelector: "name", showFilter: true },
            { type: "select", name: "status", title: "Status", placeholder: "Filter By Status", optionsQuery: SubrogationStatusOptionsQuery, valueSelector: "name", labelSelector: "description", showFilter: true },
            { type: "boolean", name: "inLitigation", title: "In Litigation", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By In Litigation", showFilter: true },
            { type: "boolean", name: "externalIdIsNull", title: "Claim ID Is Null", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Claim ID Is Null", showFilter: true },
            { type: "select", name: "externalIdKeys", title: "Legacy Systems", placeholder: "Filter By Legacy Systems", options: LEGACY_SYSTEM_OPTIONS, showFilter: true, isMulti: true },
            { type: "select", name: "incidentBranchIds", title: "Incident Branches", placeholder: "Filter By Incident Branches", optionsQuery: AllBranchesQuery, valueSelector: "id", labelSelector: "name", showFilter: true, isMulti: true },
            { type: "select", name: "assignedTo", title: "Assigned Reps", valueSelector: "id", labelSelector: "name", optionsQuery: RepsQuery, variables: { groups: ["FNOL"], orderBy: ["username"] }, placeholder: "Filter By Assigned Reps", showFilter: true, isMulti: true },
            { type: "date", name: "incidentDate", title: "Incident Date", placeholder: "Filter By Incident Date", showFilter: true },
            { type: "dateRange", name: "dateAdded", title: "Date Added", showFilter: true },
            { type: "number", name: "requestedAmountGte", title: "Requested Amount Min", placeholder: "0", showFilter: true },
            { type: "number", name: "requestedAmountLte", title: "Requested Amount Max", placeholder: "10000", showFilter: true },
            { type: "number", name: "grossCollectedGte", title: "Gross Collected Min", placeholder: "0", showFilter: true },
            { type: "number", name: "grossCollectedLte", title: "Gross Collected Max", placeholder: "10000", showFilter: true },
            { type: "boolean", name: "isArchived", title: "Is Archived", optionOne: "YES", optionTwo: "NO", placeholder: "Filter By Is Archived", showFilter: true },
        ]
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    updateSearchTerm = (searchTerm) => {
        updateFilters({ ...this.props.filterValues, searchTerm }, this.state.configurations, this.props.navigate, this.props.location, this.props.setFilterValues)
    }

    removeFilter = (filterName) => {
        let filterValues = this.props.filterValues
        let filterKeys = Object.keys(filterValues)
        if (filterKeys.includes(filterName)) {
            delete filterValues[filterName]
            updateFilters({ ...this.props.filterValues }, this.state.configurations, this.props.navigate, this.props.location, this.props.setFilterValues)
        }
    }

    getValueByFilterType = (filterConfigs, value) => {
        if (filterConfigs.type === "select") {
            let options = filterConfigs.options
            if (options && options.length > 0) {
                if (Array.isArray(value)) {
                    value = value.map(item => options.find(option => option.value === item)?.label).filter(item => item)
                } else {
                    if (value === true) value = 'true'
                    else if (value === false) value = 'false'
                    value = options.find(option => option.value === value)?.label
                }
            }
        } else if (filterConfigs.type === "boolean") {
            value = toTitleCase(value.toString())
        } else if (filterConfigs.type === "dateRange" || filterConfigs.type === "dateTimeRange") {
            if (!value?.start && !value?.end) return ""
            const start = value.start ? value.start : ""
            const end = value.end ? value.end : ""
            return `${start} → ${end}`
        }

        return Array.isArray(value) ? value.join(", ") : value
    }

    setFilters = () => {
        let conf = this.getFilterConfigurations()
        let configurations = conf.filter(filter => filter.showFilter).map(filter => {
            if (filter.optionsQuery) {
                let options = []
                this.props?.apolloClient?.query({
                    query: filter.optionsQuery,
                    variables: { ...filter.variables }
                }).then(result => {
                    if (result?.data?.optionsList?.edges?.length > 0) {
                        options = result.data.optionsList.edges.map(option => option.node && ({ value: option.node[filter.valueSelector], label: option.node[filter.labelSelector] }))
                    } else if (result?.data?.optionsList?.states?.length > 0) {
                        options = result.data.optionsList.states.map(option => option.node ? ({ value: option.node[filter.valueSelector], label: option.node[filter.labelSelector] }) : ({ value: option[filter.valueSelector], label: option[filter.labelSelector] }))
                    }
                    filter.options = options
                    delete filter.optionsQuery
                })
            }
            return filter
        })
        this.setState({ configurations })
    }

    getFiltersLength = () => {
        let keys = Object.keys(this.props.filterValues)
        let filtersValue = keys.filter(key => this.props.filterValues[key] !== null
            && this.state.configurations
            && this.state.configurations.find(setting => setting.name === key)
            && this.state.configurations.find(setting => setting.name === key).showFilter).length
        return filtersValue ? ` | ${filtersValue}` : ""
    }

    componentDidMount() {
        this.setFilters()
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.search !== prevProps.location.search && this.props.location.search) {
            let urlFilterValues = getFilterValuesFromQueryString(this.props.location.search, this.state.configurations)
            updateFilters({ ...this.props.filterValues, ...urlFilterValues, }, this.state.configurations, this.props.navigate, this.props.location, this.props.setFilterValues)
        }

        if (this.state.configurations !== prevState.configurations) {
            let urlFilterValues = getFilterValuesFromQueryString(this.props.location.search, this.state.configurations)
            handleConfigurationChange(prevState.configurations, this.state.configurations, urlFilterValues, this.props.setFilterValues, this.props.navigate, this.props.location, this.props.defaultFilters, updateFilters)
        }
    }

    render() {
        return (
            <Row className="pb-2">
                {this.state.openModal === "viewFilters" &&
                    <ListingFilters
                        open={this.state.openModal === "viewFilters"}
                        handleClose={() => this.toggleModal("")}
                        target="viewFilters"
                        filterValues={this.props.filterValues}
                        setFilterValues={(filters => updateFilters(filters, this.state.configurations, this.props.navigate, this.props.location, this.props.setFilterValues))}
                        filters={this.state.configurations}
                    />}
                <Col xs={12} className="mt-2">
                    <Row>
                        <Col>
                            <span className="driver-search-filter">
                                <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                                <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                            </span>
                        </Col>
                        <Col className="mt-1 p-0">
                            <a id="viewFilters" className="driver-list-button" onClick={() => this.toggleModal("viewFilters")}>
                                <i className="fa fa-sliders fa-solid fa-2x" aria-hidden="true"></i>
                                {this.getFiltersLength()}
                            </a>
                        </Col>
                    </Row>
                </Col>
                {this.props.filterValues && <Col xs={12} className="mt-2 search-filter-container">
                    {Object.keys(this.props.filterValues)
                        .filter(key => this.props.filterValues[key] !== null
                            && this.state.configurations
                            && this.state.configurations.find(setting => setting.name === key)
                            && this.state.configurations.find(setting => setting.name === key).showFilter)
                        .map(key =>
                            <span key={key} className="search-filter-preview">
                                <span>
                                    <i className="fa fa-times-circle" onClick={() => this.removeFilter(this.state.configurations.find(setting => setting.name === key).name)}></i>&nbsp;&nbsp;
                                    {this.state.configurations.find(setting => setting.name === key).title}
                                </span>
                                {this.getValueByFilterType(this.state.configurations.find(setting => setting.name === key), this.props.filterValues[key])}
                            </span>
                        )}
                </Col>}
            </Row>
        )
    }
}

export default (SubrogationClaimListHeader)
